import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import styled from 'styled-components'
import BooleanSwitcher from '../../../BooleanSwitcher/BooleanSwitcher'
import Button from '../../../Button/Button'
import { logOut } from '../../../../../actions/session'
import { Black, Dark4, Gray12, Shadow, WerfenColorLight, White } from '../../../../Constants/ColorChart'
import { connect } from 'react-redux'
import { setSettings } from '../../../../../actions/settings'
import { hideSearchBar, setTitleBar } from '../../../../../actions/ui'
import { closeApp } from '../../../../../../web/Utils/utils'
import isElectron from 'is-electron'
import {
    SET_EXPANDED_BY_DEFAULT_MUTATION,
    SET_PLAYLIST_FIRST_MUTATION,
} from './Queries/SettingsQueries'
import { Col, Container, Row } from "react-bootstrap";
import { useApolloClient, useMutation } from "@apollo/client";
import { useMatomo } from "@datapunt/matomo-tracker-react";

/*import Select from 'react-select'

const languages = [
    {
        value: "es",
        label: "Castellano"
    }, {
        value: "it",
        label: "Italiano"
    }, {
        value: "en",
        label: "English"
    }, {
        value: "de",
        label: "Deutsch"
    }
]

const fileFormats = [
    {
        value: "all",
        label: "All"
    },
    {
        value: "pdf",
        label: "PDF"
    },
    {
        value: "docx",
        label: "DOC / DOCX"
    },
    {
        value: "xlsx",
        label: "XLS / XLSX"
    },
    {
        value: "vsdx",
        label: "VSDX"
    },
    {
        value: "mp4",
        label: "MP4"
    },
    {
        value: "other",
        label: "Other"
    }
]

const SelectDiv = styled.div`
  width: 150px;
  float: right;
`;
*/

const Wrapper = styled.div`
    width: calc(100% - 100px);
    margin-right: auto;
    margin-left: 80px;
    @media screen and (min-width: 992px){
      margin-left: 280px;
      width: calc(94% - 250px); 
    }
    .TableWrapper {
    width: 100%;
    width: 100%;
    margin-bottom: 3%;
    color: ${ Black };
    padding: 2%;
    border: 2px solid rgba(0,0,0,0.05);
    background-clip: padding-box;
        .Title {
            font-size: 30px;
            margin: 10px;
        }
        .Table {
            font-size: 9px;
            @media screen and (min-width: 992px){
              font-size: 20px; 
            }
            .TableRow {
                border-top: 1px solid ${ Gray12 };
                border-bottom: 1px solid ${ Gray12 };
                font-size: 15px;
                @media (min-width: 992px) {
                    margin-left: 20px;
                }
                &:hover{
                    background: ${ Dark4 };
                    box-shadow: 0px 0px 20px ${ Shadow }; 
                }
                transition: all 100ms;
                .TableData {
                    padding-top: 20px;
                    padding-bottom: 20px;
                    padding-left: 20px;
                    &.logoutButton > div {
                        margin: 0 auto;
                        @media (max-width: 600px){
                            width: 100%;
                        }
                    }
                    @media (max-width: 991px){
                        &+ .TableData {
                            padding-top: 0px
                        }
                        &:empty {
                            display: none;
                            &+ .TableData {
                                padding-top: 20px;
                            }
                        }
                    }
                }
                
            }
        ]
    }
`;

export const Switch = ( props ) => {
    const { setOption, option, mutation } = props
    const [ switchOption ] = useMutation ( mutation );

    return (
        <BooleanSwitcher
            isActive={ option }
            onClick={ () => {
                switchOption ( {
                    variables: {
                        input: !option
                    }
                } )
                    .catch ( error => console.error ( { error } ) );
                setOption ( !option )
            } }
        />
    )
}


/*const Selector = (props)=>{
    const { option, options, setOption, mutation } = props;
    const [ selectOption, {data, loading, error}] = useMutation(mutation);
    const defaultValue = options.find(item => item.value === option);

    if ( loading ) {
        console.info( { loading } )
    }
    if ( error ) {
        console.error( { error } )
    }
    if ( data ) {
        console.info( { data } )
    }

    return(
        <SelectDiv>
            <Select
                isRtL={true}
                isSearchable={false}
                options={options}
                defaultValue={defaultValue}
                onChange={(event)=>{
                    setOption(event.target.value);
                    selectOption(option).catch(error=>console.error(error));
                }}
            />
        </SelectDiv>
    )
}*/

const SettingsSection = ( props ) => {
    const [ playlistsFirst, setPlaylistsFirst ] = useState ( props.settings.playlistsFirst );
     const [ expandedByDefault, setExpandedByDefault ] = useState ( props.settings.expandedByDefault || false);
    // const [ syncDownloads, setSyncDownloads ] = useState( props.settings.syncDownloads );
    // const [ preferredLanguage, setPreferredLanguage ] = useState( props.settings.preferredLanguage );
    // const [ preferredFileFormat, setPreferredFileFormat ] = useState( props.settings.preferredFileFormat );

    const client = useApolloClient ();
    const history = useHistory ();
    const { pushInstruction } = useMatomo ();

    useEffect ( () => {
        props.hideSearchBar ();
        props.setTitleBar ( "Profile / Settings" );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect ( () => {
        const settings = {
            playlistsFirst,
            expandedByDefault,
            // syncDownloads,
            // preferredLanguage,
            // preferredFileFormat
        }
        props.setSettings ( settings );

        return () => {

        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ playlistsFirst, expandedByDefault, /*syncDownloads, preferredLanguage, preferredFileFormat*/ ] );

    const getLogout = () => {
        // TODO: Change this analytics code and put it into functions

        const application = isElectron () ? "- Desktop" : "- Web"
        const user = props.session.user;

        pushInstruction ( 'setUserId', user );
        pushInstruction ( 'setDocumentTitle', "Logout Action " );
        pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
        pushInstruction ( 'trackEvent', "WDOCS " + application, "logout", user );
        pushInstruction ( 'trackPageView' );

        pushInstruction ( 'resetUserId' );
        pushInstruction ( 'appendToTrackingUrl', "new_visit=1" );
        pushInstruction ( 'trackPageView' );
        pushInstruction ( 'appendToTrackingUrl', '' );

        props.logOut ();

        client.resetStore ().then ( () => {
            client.clearStore ().then ( () => {
                if ( isElectron () ) {
                    history.push ( "/" );
                } else {
                    window.location.replace ( "/" );
                }
            } );
        } );

    }

    return (
        <Wrapper>
            <div className={ "TableWrapper" }>
                <div className="Title">General Settings</div>
                <Container fluid className={ "Table" }>
                    <Row className={ "TableRow" }>
                        <Col xs={ 12 } md={ 6 } className={ "TableData text-start" }>
                            Show playlists first
                        </Col>
                        <Col xs={ 12 } md={ 6 } className={ "TableData text-end" }>
                            <Switch
                                option={ playlistsFirst }
                                setOption={ setPlaylistsFirst }
                                mutation={ SET_PLAYLIST_FIRST_MUTATION }
                            />
                        </Col>
                    </Row>
                    <Row className={ "TableRow" }>
                        <Col xs={ 12 } md={ 6 } className={ "TableData text-start" }>
                            Show descriptions expanded by default
                        </Col>
                        <Col xs={ 12 } md={ 6 } className={ "TableData text-end" }>
                            <Switch
                                option={ expandedByDefault }
                                setOption={ setExpandedByDefault }
                                mutation={ SET_EXPANDED_BY_DEFAULT_MUTATION }
                            />
                        </Col>
                    </Row>
                    {/*<Row className={ "TableRow" }>*/ }
                    {/*    <Col xs={ 12 } md={ 6 } className={ "TableData text-start" }>*/ }
                    {/*        Automatically synchronize offline files*/ }
                    {/*    </Col>*/ }
                    {/*    <Col xs={ 12 } md={ 6 } className={ "TableData text-end" }>*/ }
                    {/*        <Switch*/ }
                    {/*            option={ syncDownloads }*/ }
                    {/*            setOption={ setSyncDownloads }*/ }
                    {/*            mutation={SET_SYNC_ON_STARTUP_MUTATION}*/ }
                    {/*        />*/ }
                    {/*    </Col>*/ }
                    {/*</Row>*/ }
                    {/*<Row className={ "TableRow" }>*/ }
                    {/*    <Col xs={ 12 } md={ 6 } className={ "TableData text-start" }>*/ }
                    {/*        Preferred file language*/ }
                    {/*    </Col>*/ }
                    {/*    <Col xs={ 12 } md={ 6 } className={ "TableData text-end" }>*/ }
                    {/*        <Selector*/ }
                    {/*            option={ preferredLanguage }*/ }
                    {/*            options={ languages }*/ }
                    {/*            setOption={ setPreferredLanguage }*/ }
                    {/*            mutation={SET_PREFERRED_LANGUAGE_MUTATION}*/ }
                    {/*        />*/ }
                    {/*    </Col>*/ }
                    {/*</Row>*/ }
                    {/*<Row className={ "TableRow" }>*/ }
                    {/*    <Col xs={ 12 } md={ 6 } className={ "TableData text-start" }>*/ }
                    {/*        Preferred file format*/ }
                    {/*    </Col>*/ }
                    {/*    <Col xs={ 12 } md={ 6 } className={ "TableData text-end" }>*/ }
                    {/*        <Selector*/ }
                    {/*            option={ preferredFileFormat }*/ }
                    {/*            options={ fileFormats }*/ }
                    {/*            setOption={ setPreferredFileFormat }*/ }
                    {/*            mutation={SET_PREFERRED_DEFAULT_FORMAT_MUTATION}*/ }
                    {/*        />*/ }
                    {/*    </Col>*/ }
                    {/*</Row>*/ }
                    { !isElectron () && <Row className={ "TableRow" }>
                        <Col xs={ 12 } className={ "TableData logoutButton" }>
                            <Button
                                background={ WerfenColorLight }
                                color={ White }
                                text="Log Out"
                                onClick={ getLogout }
                            />

                        </Col>
                    </Row> }
                    { isElectron () &&
                        <Row className={ "TableRow" }>
                            <Col xs={ 12 } md={ { span: 6, offset: 6 } } className={ "TableData text-end" }>

                                <Button
                                    background={ White }
                                    color={ WerfenColorLight }
                                    border={ WerfenColorLight }
                                    text="Log Out"
                                    display="inline-block"
                                    onClick={ getLogout }
                                />
                                <Button
                                    background={ WerfenColorLight }
                                    border={ WerfenColorLight }
                                    color={ White }
                                    text="Close Application"
                                    display="inline-block"
                                    onClick={ closeApp }
                                />

                            </Col>
                        </Row>
                    }
                </Container>
            </div>
        </Wrapper>
    )
}

const mapStateToProps = ( state ) => ( {
    settings: state.settings,
    session: state.session
} );

export default connect ( mapStateToProps, { setSettings, logOut, setTitleBar, hideSearchBar } ) ( SettingsSection )